// src/utils/roleMap.js

// Canônicos do Backend/App: 
// admin, root, presidente, vereador, secretario, servidor, executivo, painel, obspainel

export function mapToCanonicalRole(raw = "") {
  const s = String(raw)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

  // === 1. ROLES DE SISTEMA (Prioridade Alta para não cair no fallback) ===
  if (s === "root") return "root";
  if (s === "admin" || s === "administrador" || s === "administradora") return "admin";
  
  // Impede que executivo vire servidor
  if (s.includes("executivo") || s === "prefeito" || s === "prefeita") return "executivo";

  // Impede que painéis virem servidor
  if (s === "painel" || s === "tv" || s === "telao") return "painel";
  if (s === "obspainel" || s === "obs" || s.includes("observador")) return "obspainel";

  // === 2. MESA DIRETORA E PARLAMENTARES (Tratamento de Gênero) ===
  
  // Presidente
  if (s === "presidente" || s === "presidenta") return "presidente";

  // Vereador / Vereadora
  // O includes pega "vereadora", "vereadores", etc.
  if (s.includes("vereador")) return "vereador";

  // Secretários e Vices (Mapeados para Vereador conforme sua regra anterior)
  // Regex para pegar "primeiro", "primeira", "1", "1º", "1ª" seguido de secretario(a)
  if (/^(primeir[oa]|1[ºª]?|vice)\s+secretari[oa]$/.test(s)) return "vereador";
  if (/^(primeir[oa]|1[ºª]?|vice)\s+presidente$/.test(s)) return "vereador";
  
  // Caso a role venha apenas como "secretario" ou "secretaria" (sem ser o 1º)
  // Se no seu sistema o cargo "Secretário" tem acesso especial (ex: painel de controle), mantenha como 'secretario'.
  // Caso contrário, mapeie para 'vereador'. Vou manter 'secretario' se for a string exata.
  if (s === "secretario" || s === "secretaria") return "secretario";

  // === 3. SERVIDORES ===
  if (s === "servidor" || s === "servidora" || s === "funcionario" || s === "funcionaria") return "servidor";

  // === 4. CHECAGEM FINAL (Pass-through) ===
  // Se a string já for exatamente uma das roles válidas, retorna ela mesma.
  const validRoles = [
    "admin", "root", "presidente", "vereador", 
    "secretario", "servidor", "executivo", 
    "painel", "obspainel"
  ];
  
  if (validRoles.includes(s)) return s;

  // === 5. FALLBACK ===
  // CUIDADO: Só cai aqui se não for NENHUM dos acima.
  return "servidor";
}